"use strict";

const Floorplans = () => {
    const init = () => {
        $(function() {
            $('.js-prefill-form').click(function () {
               var button = $(this);

                var $contact_form = $('.js-contact-form');
                if ($contact_form.length > 0) {
                    $contact_form.each(function() {
                        $(this).find('[name="interest"]').val(button.attr('data-interest')).niceSelect('update').parents('.form-group').addClass('filled');
                        $(this).find('[name="content_message"]').val(button.attr('data-message')).parents('.form-group').addClass('filled');
                    })
                }
            });

            var $floorplansContainer = $('.js-floorplans');
            if ($floorplansContainer.length > 0) {
                var $levels = $floorplansContainer.find('.js-floorplan-level');
                var $levelImages = $floorplansContainer.find('.js-floorplan-level-image');
                var $worm = $floorplansContainer.find('.js-floorplan-level-worm');
                
                $levels.on('click', function(){
                    $levels.removeClass('active');
                    $levels.filter('[data-id="'+$(this).data('id')+'"]').addClass('active');
                    $levelImages.hide();
                    $levelImages.filter('[data-id="'+$(this).data('id')+'"]').show();
                    $worm.css('transform', 'translateX('+(100 * ($(this).data('id') - 1))+'%)');
                });

                $levels.filter('[data-id="1"]').trigger('click');

                var $options = $floorplansContainer.find('.js-floorplan-option');
                
                $options.on('click', function(){
                    var $this = $(this);
                    var $optionImages = $this.parents('.js-tabs-page').find('.js-floorplan-option-image');
                    var conflicts = $this.data('conflicts');
                    if($this.hasClass('active')){
                        $this.removeClass('active');
                        $optionImages.filter('[data-id="'+$this.data('id')+'"]').hide();
                    }else{
                        $this.addClass('active');
                        $optionImages.filter('[data-id="'+$this.data('id')+'"]').show();
                        if(conflicts.length){
                            $.each(conflicts, function(index, value){
                                var $conflict = $this.siblings().filter('[data-id="'+value+'"]');
                                if($conflict.hasClass('active')){
                                    $conflict.click();
                                }
                            });
                        }
                    }
                });
            }
        });
    };

    return {
        init:init
    };
};

export default Floorplans;